<template>
	<span :key="currency">{{ output }}</span>
</template>
<script>
import helper from '@/mixins/helper'
export default {
	props: {
		value: {
	      type: Number,
	      default: 0
	    },
		currency: {
	      type: String,
	      default: ''
	    },
		format: {
	      type: String,
	      default: '%amount %currency'
	    }
	},
	data() {
		return {
		}
	},
	computed: {
		my_currency() {
			return this.currency || this.$t('currency')
		},
		amount() {
			this.currency;
			return this.money(this.value, this.my_currency.toLowerCase())
		},
		output() {
			let output = this.format.replace(/\%amount/g, this.$options.filters.formatMoney(this.amount)).replace(/\%currency/g, this.my_currency)
			return output
		}
	},
	mixins: [helper]
}
</script>
<style>

</style>